import { ReactNode } from 'react';
import { Card, Metric, Text, BadgeDelta } from '@tremor/react';
import { LoadingSkeleton } from './LoadingSkeleton';

export interface KPICardProps {
  label: string;
  value?: string | null;
  delta?: number | null;
  hint?: string;
  loading?: boolean;
  error?: string | null;
  footer?: ReactNode;
}

export function KPICard({
  label,
  value,
  delta,
  hint,
  loading,
  error,
  footer,
}: KPICardProps) {
  return (
    <Card className="space-y-2">
      <Text>{label}</Text>
      {loading && <LoadingSkeleton rows={2} />}
      {!loading && error && (
        <div className="text-sm text-red-400" role="alert">
          {error}
        </div>
      )}
      {!loading && !error && (
        <>
          <div className="flex items-center gap-2">
            <Metric>{value ?? '—'}</Metric>
            {typeof delta === 'number' && (
              <BadgeDelta
                deltaType={
                  delta > 0 ? 'increase' : delta < 0 ? 'decrease' : 'unchanged'
                }
              >
                {`${delta > 0 ? '+' : ''}${(delta * 100).toFixed(1)}%`}
              </BadgeDelta>
            )}
          </div>
          {hint && <Text className="text-xs">{hint}</Text>}
          {footer && <div className="pt-1">{footer}</div>}
        </>
      )}
    </Card>
  );
}
